import { SvgIcon } from '@mui/material'
import { lazy, Suspense } from 'react'

import Loading from 'components/Loading'

const YieldbirdFullSvg = lazy(() => import('images/logos/yieldbird-full.svg?react'))

export const FullLogotype = (): React.JSX.Element => (
  <Suspense fallback={<Loading />}>
    <SvgIcon
      component={YieldbirdFullSvg}
      inheritViewBox
      sx={{
        height: 'inherit',
        width: 'inherit',
      }}
    />
  </Suspense>
)
